export const FAVORITES_KEY = 'music_room_favorites'

function normalizeId(value) {
    if (value == null || value === '') return ''
    return String(value).trim()
}

export function normalizeSong(row) {
    if (!row || typeof row !== 'object') return null
    const id = normalizeId(row.id || row.musicId || row.mid)
    if (!id || id === 'placeholder') return null
    const album = row.album && typeof row.album === 'object' ? row.album : null
    const pictureUrl = row.pictureUrl || row.picture_url
        || (album && (album.pictureUrl || album.picture_url))
        || ''
    const albumName = album && (album.name || album.title) ? (album.name || album.title) : (typeof row.album === 'string' ? row.album : '')
    return {
        id: id,
        name: row.name || row.title || id,
        artist: row.artist || row.singerName || '未知歌手',
        album: albumName ? { name: albumName, pictureUrl: pictureUrl, picture_url: pictureUrl } : (album || null),
        pictureUrl: pictureUrl,
        picture_url: pictureUrl,
        source: row.source || 'qq',
        duration: row.duration || 0
    }
}

export function listFavorites() {
    try {
        const raw = window.localStorage.getItem(FAVORITES_KEY)
        const list = raw ? JSON.parse(raw) : []
        if (!Array.isArray(list)) return []
        return list.map(normalizeSong).filter(Boolean)
    } catch (e) {
        return []
    }
}

function persist(list) {
    window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(list))
    return list
}

export function isFavorite(id, list) {
    const key = normalizeId(id)
    if (!key) return false
    const source = Array.isArray(list) ? list : listFavorites()
    return source.some((item) => normalizeId(item && item.id) === key)
}

export function addFavorite(row) {
    const song = normalizeSong(row)
    if (!song) return listFavorites()
    const current = listFavorites().filter((item) => normalizeId(item.id) !== song.id)
    current.unshift(song)
    return persist(current)
}

export function removeFavorite(id) {
    const key = normalizeId(id)
    if (!key) return listFavorites()
    return persist(listFavorites().filter((item) => normalizeId(item.id) !== key))
}

export function toggleFavorite(row) {
    const song = normalizeSong(row)
    if (!song) return { list: listFavorites(), added: false }
    if (isFavorite(song.id)) {
        return { list: removeFavorite(song.id), added: false }
    }
    return { list: addFavorite(song), added: true }
}

export function clearFavorites() {
    return persist([])
}

export function mergeFavorites(incoming) {
    const extras = Array.isArray(incoming) ? incoming : []
    const mapped = extras.map(normalizeSong).filter(Boolean)
    const seen = {}
    const merged = []
    mapped.concat(listFavorites()).forEach((item) => {
        const id = normalizeId(item.id)
        if (!id || seen[id]) return
        seen[id] = true
        merged.push(item)
    })
    return persist(merged)
}
